import track from 'c9-tracking';
import { IRouterPage, Selection } from '../interfaces/interfaces';

// Do Not Track. Add field names here that should not be tracked
export const DNT = ['cprNo', 'bankAccountNumber', 'bankRegNumber'];

//These values are removed from the selection object
export const removeTrackValues = ['manufactor', 'model', 'variantId'];

export const isBoolean = (val: unknown) => 'boolean' === typeof val;

/**
 * Prettyprint values for tracking framework
 */
export const prettyPrint = (v: any) => {
    if (v && typeof v === 'object' && !Array.isArray(v)) {
        //const val: keyof typeof v = v as keyof typeof v;
        if (v.address) {
            return v.address;
        } else if (v.packageName) {
            return v.packageName;
        }
    } else if (v && Array.isArray(v) && v.some((e) => e['coverageAlias'])) {
        //selectedAdditionalCoverages is an array
        return v.map((x) => x.coverageAlias).join(', ');
    }
    return isBoolean(v) ? (v ? 'Ja' : 'Nej') : typeof v === 'object' ? JSON.stringify(v) : v;
};

// track page submit and form elements
export const defaultTracking = (currentPage: IRouterPage | undefined, selection: Selection, formKeys: string[]) => {
    const trackValues = formKeys
        .filter((el: string) => !removeTrackValues.includes(el))
        .map((k) => {
            const v = selection[k];
            const trackVal = DNT.includes(k) ? '*MASKED*' : v;
            return { id: k, value: prettyPrint(trackVal) as string };
        });
    track.form(`form-${currentPage?.key}`, trackValues);
};
